import { findSchemaDefinition, type RJSFSchema } from "@rjsf/utils";

export const getSchemaAtPath = (schema: RJSFSchema, dataPath: string): RJSFSchema | undefined => {
  const parts = dataPath
    .replace(/^\./, "") // remove leading dot
    .replace(/\[\d+\]/g, "") // remove array indices
    .split(".");

  return parts.reduce<RJSFSchema | undefined>((current, part) => {
    if (!current) return;

    // Handle array type
    if (current.type === "array") {
      let items = current.items as RJSFSchema;
      if (items && items.$ref) {
        items = findSchemaDefinition(items.$ref, schema);
      }
      current = items;
    }

    // Handle object properties
    if (current && current.properties && current.properties[part]) {
      let next = current.properties[part] as RJSFSchema;
      if (next && next.$ref) {
        next = findSchemaDefinition(next.$ref, schema);
      }
      return next;
    }

    return;
  }, schema);
};
